import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import GovernmentPage from "@/pages/GovernmentPage";

export const Route = createFileRoute("/government")({
  head: () => pageHead("Government Solutions", "AI engineering for Federal agencies, aligned to America's AI Action Plan, OMB M-25-21 and M-25-22, and the Genesis Mission.", "/government", false),
  component: GovernmentPage,
});
